import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HowToGetHere.css';
import { weddingConfig } from '../config/weddingConfig';

const HowToGetHere = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const resort = weddingConfig.resort;
  const transport = weddingConfig.transportation;

  return (
    <div className="how-to-get-here-container">
      <div className="container">
        <button
          className="back-button"
          onClick={() => navigate('/')}
          style={{
            fontFamily: weddingConfig.design.fonts.body,
            color: weddingConfig.design.colors.primary,
            borderColor: weddingConfig.design.colors.primary
          }}
        >
          ← Back
        </button>
        <h1 className="page-title" style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary }}>
          How to Get Here
        </h1>
        <div className="page-content" style={{ fontFamily: weddingConfig.design.fonts.body, color: weddingConfig.design.colors.secondary }}>
          <div className="venue-info">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary }}>
              Venue
            </h2>
            <p style={{ fontSize: '1.2rem', fontWeight: 600, marginBottom: '10px' }}>
              {resort.name}
            </p>
            <p style={{ marginBottom: '15px' }}>
              {resort.address}
            </p>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${resort.gpsCoordinates.latitude.replace('°', '').replace(' N', '')},${resort.gpsCoordinates.longitude.replace('°', '').replace(' E', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="maps-link"
              style={{
                color: weddingConfig.design.colors.primary,
                fontWeight: 600,
                textDecoration: 'none',
                borderBottom: `2px solid ${weddingConfig.design.colors.primary}`,
                paddingBottom: '2px',
                transition: 'all 0.3s ease',
                display: 'inline-block'
              }}
            >
              Open in Maps →
            </a>
          </div>
          
          <div className="transport-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              By Air
            </h2>
            <div className="info-box">
              <p>
                <strong>{transport.airport.name}</strong> - {transport.airport.description}
              </p>
              <p>
                <strong>Travel time from airport:</strong> {transport.airport.travelTime}
              </p>
              <p>
                <strong>Taxis:</strong> Pre-paid taxi counters are available at the airport. Note that app-based services like Ola and Uber do not operate in Goa .You'll need to use local taxi services.
              </p>
            </div>
          </div>
          
          <div className="transport-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              By Train
            </h2>
            <div className="info-box">
              <p>
                <strong>{transport.train.primary.name}</strong> - {transport.train.primary.description}
              </p>
              <p>
                <strong>Travel time from station:</strong> {transport.train.primary.travelTime}
              </p>
              <p>
                <strong>{transport.train.secondary.name}</strong> - {transport.train.secondary.description}
              </p>
              <p>
                Local taxis and auto-rickshaws are available at both stations. Pre-paid taxi counters are also available.
              </p>
            </div>
          </div>
          
          <div className="transport-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              By Road
            </h2>
            <div className="info-box">
              <p>
                Goa is well-connected by road. You can drive or take a bus from major cities like Mumbai, Pune, or Bangalore.
              </p>
              <p>
                <strong>From Mumbai:</strong> Approximately {transport.road.fromMumbai.distance} ({transport.road.fromMumbai.time})
              </p>
              <p>
                <strong>From Pune:</strong> Approximately {transport.road.fromPune.distance} ({transport.road.fromPune.time})
              </p>
              <p>
                <strong>From Bangalore:</strong> Approximately {transport.road.fromBangalore.distance} ({transport.road.fromBangalore.time})
              </p>
              <p>
                The venue is easily accessible via {transport.road.highway}.
              </p>
            </div>
          </div>
          
          <div className="transport-section">
            <h2 style={{ fontFamily: weddingConfig.design.fonts.heading, color: weddingConfig.design.colors.primary, marginTop: '40px' }}>
              Local Transportation
            </h2>
            <div className="info-box">
              <p>
                <strong>Important note:</strong> App-based taxi services (Ola, Uber) do not operate in South Goa. You will need to rely on local taxi services, which are readily available.
              </p>
              <p>
                <strong>Local Taxis:</strong> Available at the resort, railway stations, and airport. It's advisable to confirm rates before starting your journey.
              </p>
              <p>
                <strong>Rental Cars:</strong> Several car rental agencies operate at the airport and in Margao town.
              </p>
              <p>
                <strong>Two-wheelers:</strong> Scooter and bike rentals are available and popular for exploring the area independently.
              </p>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default HowToGetHere;

